export default {"src":"/_next/static/media/zwaardvechten.4e6166db.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};